import { Breadcrumb, Button, Col, Layout, Row, Typography } from 'antd';
import { FC } from "react";
import { FloatingWhatsApp } from 'react-floating-whatsapp';
import { Link } from "react-router-dom";
import supportAvatar from '../assets/support.jpg';
import { useTranslation } from 'react-i18next';
import { useAppLanguage } from '../hooks/useAppLanguage';

const { Content } = Layout;

interface IIndexPageProps { };

export const IndexPage: FC<IIndexPageProps> = (props) => {
  const { t } = useTranslation();
  const { language } = useAppLanguage();

  return (
    <Layout>
      <Content style={{ padding: '0 50px 50px 50px', width: 1150, margin: "auto" }}>
        <Breadcrumb style={{ margin: '16px 0' }}>
          <Breadcrumb.Item>Home</Breadcrumb.Item>
          <Breadcrumb.Item>{t('common.products')}</Breadcrumb.Item>
        </Breadcrumb>

        <Row style={{ background: "#fff", borderRadius: 10 }}>
          <Col xs={24} sm={24} md={12}>
            <div style={{ padding: "32px 48px" }}>
              <Typography.Title
                style={{
                  //color: "white",
                }}
              >
                {t('index.title')}
              </Typography.Title>

              <div style={{ height: 30 }} />

              <Link to={`/gofarm?language=${language}`}>
                <Button
                  style={{
                    padding: "8px 24px",
                    fontSize: 21,
                    height: "inherit",
                  }}
                  type="primary"
                >
                  {t('index.discover')}
                </Button>
              </Link>
            </div>

          </Col>
          <Col xs={24} sm={24} md={12}>
            <img
              src="img/farm.jpg"
              alt="banner"
              style={{
                objectFit: "cover",
                width: '100%',
                height: 300,
                filter: "opacity(0.9)",
                borderTopRightRadius: 10,
                borderBottomRightRadius: 10,
              }}
            />
          </Col>
        </Row>

        <div style={{ height: 30 }} />

        <Row style={{ background: "#fff", borderRadius: 10 }}>
          <Link to={`/gofarm?language=${language}`} style={{ textAlign: "center", width: "100%" }}>
            <img src="img/gofarm.png" height={300} alt="GoFarm Logo" />
          </Link>
        </Row>

        <FloatingWhatsApp
          accountName="Suporte Tecgraf Agro"
          phoneNumber="+5519999174690"
          avatar={supportAvatar}
          statusMessage={t('common.support_status')}
          chatMessage={t('common.support_message')}
          placeholder={t('common.whatsapp_placeholder')}
        />

      </Content>
    </Layout>
  );
}
